import { Signal } from "@lit-labs/signals";
import type { ILiveEventAccessRequestState, AccessRequestStatus } from "./types";

export class LiveEventAccessRequestState implements ILiveEventAccessRequestState {
  readonly requestStatus = new Signal.State<AccessRequestStatus>(null);
  readonly loading = new Signal.State<boolean>(false);
  readonly submitting = new Signal.State<boolean>(false);

  hasPendingRequest(): boolean {
    return this.requestStatus.get() === "pending";
  }
}
